import { render, staticRenderFns } from "./weixinLogin.vue?vue&type=template&id=d200677e&scoped=true&"
import script from "./weixinLogin.vue?vue&type=script&lang=js&"
export * from "./weixinLogin.vue?vue&type=script&lang=js&"
import style0 from "./weixinLogin.vue?vue&type=style&index=0&id=d200677e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d200677e",
  null
  
)

export default component.exports